export const registrationValidation = (value, rules) => {
  let errors = [];

  rules.forEach((rule) => {
    if (rule.type === "required" && !value) {
      errors.push(`${rule.name} field must not be empty`);
    }
    if (rule.type === "string" && typeof value !== "string") {
      errors.push(`${rule.name} must be a valid string`);
    }
    if (rule.type === "email" && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
      errors.push(`${rule.name} is not a valid email`);
    }
    if (rule.type === "minLength" && value?.length < rule.length) {
      errors.push(`${rule.name} must be at least ${rule.length} characters`);
    }
    if (rule.type === "maxLength" && value?.length > rule.length) {
      errors.push(`${rule.name} must not exceed ${rule.length} characters`);
    }
    if (rule.type === "onlyLetters" && !/^[A-Za-z ]+$/.test(value)) {
      errors.push(`${rule.name} must contain only letters`);
    }
    if (rule.type === "phone" && !/^\d{10}$/.test(value)) {
      errors.push(`${rule.name} must be a 10-digit number`);
    }
    if (rule.type === "imageFile" && value) {
      const validFormats = ["image/jpeg", "image/png"];
      if (!validFormats.includes(value.type)) {
        errors.push(`${rule.name} must be a PNG, JPG or JPEG file.`);
      }
      if (value.size > 2 * 1024 * 1024) {
        errors.push(`${rule.name} must be less than 2MB.`);
      }

      return new Promise((resolve) => {
        const img = new Image();
        img.src = URL.createObjectURL(value);
        img.onload = () => {
          if (img.width < 300 || img.height < 300) {
            errors.push(`${rule.name} must be at least 300x300px.`);
          }
          if (img.width < 500 || img.height < 500) {
            
          }
          resolve(errors.length > 0 ? errors[0] : "");
        };
      });
    }
  });

  return errors.length > 0 ? errors[0] : "";
};
